import { render, staticRenderFns } from "./backGoodsorderWindow.vue?vue&type=template&id=1d2cd0ba&scoped=true&"
import script from "./backGoodsorderWindow.vue?vue&type=script&lang=js&"
export * from "./backGoodsorderWindow.vue?vue&type=script&lang=js&"
import style0 from "./backGoodsorderWindow.vue?vue&type=style&index=0&id=1d2cd0ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2cd0ba",
  null
  
)

export default component.exports